module.exports = __webpack_public_path__ + "static/media/wbtc.e23c8c41.svg";